import React, {Component} from 'react';
import LocalizedAddress from "../views/member/components/LocalizedAddress";
import PropTypes from "prop-types";
import { TranslationContext } from "@c/Translations";

class ShippingAddress extends Component {
  render() {
    return (
      <TranslationContext.Consumer>
        {t =>
          <section className="checkout-form__section">
            <div className='input'>
              <div
                className={`input__checkbox tos__checkbox ${!this.props.useShippingAddress ? 'input__checkbox--selected' : ''}`}>
                <div className="input__checkbox-wrap">
                  <div className="input__checkbox__input">
                    <input type="checkbox" name="use_shipping_address" id="use_shipping_address"
                           onChange={this.props.onUseShippingAddressChange} checked={this.props.useShippingAddress}/>
                  </div>
                  <label htmlFor="use_shipping_address" className="input__checkbox__label">
                    {t.t(this.props.customerAddress ? 'checkout__use_customer__address': 'checkout__use_delivery_address')}
                  </label>
                </div>
              </div>
            </div>
            <div>
              {!this.props.useShippingAddress &&
                <LocalizedAddress
                  {...this.props.address}
                  onAddressChange={this.props.onAddressChange}
                  header={t.t('checkout__delivery_address')}
                />
              }
            </div>
          </section>
        }
      </TranslationContext.Consumer>
    )
  }
}

ShippingAddress.propTypes = {
  address: PropTypes.object.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  useShippingAddress: PropTypes.bool.isRequired,
  onUseShippingAddressChange: PropTypes.func.isRequired,
}

export default ShippingAddress;
